import { render, staticRenderFns } from "./OperatorOperatorAccess.vue?vue&type=template&id=1f5f5462"
import script from "./OperatorOperatorAccess.vue?vue&type=script&lang=js"
export * from "./OperatorOperatorAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports